import { Component, type ErrorInfo, type ReactNode } from 'react';
import { AlertTriangle } from 'lucide-react';
import i18n from '../i18n'; // class component: niente hook, t diretto

interface Props { children: ReactNode }
interface State { hasError: boolean }

/**
 * Boundary di pagina: un errore di rendering (es. un detail API renderizzato come
 * oggetto) degrada a messaggio invece di pagina bianca. In AppLayout è keyed sul
 * pathname → navigando verso un'altra pagina il boundary si resetta da solo.
 */
export default class ErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('ErrorBoundary: errore di rendering', error, info); // i18n-ignore: log dev, non UI
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="flex flex-col items-center justify-center h-full gap-3 p-8 text-center">
          <AlertTriangle className="text-accent-danger" size={32} />
          <h2 className="text-lg font-semibold text-ink-dark">{i18n.t('common.errore_boundary.titolo')}</h2>
          <p className="text-sm text-ink-soft max-w-md">
            {i18n.t('common.errore_boundary.testo')}
          </p>
          <button
            type="button"
            onClick={() => this.setState({ hasError: false })}
            className="mt-2 px-4 py-2 text-sm font-medium text-white bg-sage rounded-lg hover:bg-sage-dark transition-colors"
          >
            {i18n.t('common.azioni.riprova')}
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
